import './PageSkeleton.css'

export function PageSkeleton() {
  return (
    <div className="page-skeleton">
      <div className="skeleton page-skeleton__title" />
      <div className="page-skeleton__cards">
        <div className="skeleton page-skeleton__card" />
        <div className="skeleton page-skeleton__card" />
        <div className="skeleton page-skeleton__card" />
        <div className="skeleton page-skeleton__card" />
      </div>
      <div className="skeleton page-skeleton__table" />
    </div>
  )
}
